import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CallsListTab, { CallsListTabProps } from './calls-list-tab';
import { getCallLogsProspectDrawerHeaderRequest } from '../../../../../../../dialer/extra-actions';
import { prospectCallLogsDrawerHeaderPayload } from '../../../../../../../dialer/types';
import { RootState } from '../../../../../../../../store/root-reducer';
import { resetGetCallLogsProspectDrawerHeaderRequest } from '../../../../../../../dialer/dialer-slice';

const CallsListTabContainer = memo((props: CallsListTabProps) => {
  const dispatch = useDispatch();

  const getCallLogsProspectDrawerHeaderResponse = useSelector(
    (state: RootState) => state.dialer.getCallLogsProspectDrawerHeaderResponse,
  );
  const userTimeZone = useSelector((state: RootState) => state?.home?.timeZone);
  const getCallLogsProspectDrawerHeaderRequestStatus = useSelector(
    (state: RootState) =>
      state?.dialer?.getCallLogsProspectDrawerHeaderRequest?.status,
  );

  const sendGetCallLogsProspectDrawerHeaderRequest = useCallback(
    (payload: prospectCallLogsDrawerHeaderPayload) => {
      dispatch(getCallLogsProspectDrawerHeaderRequest(payload));
    },
    [dispatch],
  );
  const resetGetCallLogsProspectDrawerHeader = useCallback(() => {
    dispatch(resetGetCallLogsProspectDrawerHeaderRequest());
  }, [dispatch]);

  return (
    <CallsListTab
      {...props}
      getCallLogsProspectDrawerHeaderResponse={
        getCallLogsProspectDrawerHeaderResponse
      }
      sendGetCallLogsProspectDrawerHeaderRequest={
        sendGetCallLogsProspectDrawerHeaderRequest
      }
      resetGetCallLogsProspectDrawerHeader={
        resetGetCallLogsProspectDrawerHeader
      }
      getCallLogsProspectDrawerHeaderRequestStatus={
        getCallLogsProspectDrawerHeaderRequestStatus
      }
      userTimeZone={userTimeZone}
    />
  );
});

export default CallsListTabContainer;
